<template lang="pug">
div.tree-view
    div.tree-item(v-for="(node, nKey) in nodes" :key="nKey")
        div.tree-node
            div.node-icon
                div.node-icon__default(v-if="!node.hasChild")
                svg-icon(
                    v-else
                    name='folder' size="small"
                    :class="isNodeExpanded(node.jsonKey.name) ? 'node-icon__open' : 'node-icon__close'"
                    @click.native="expandNode(node)")
            div.tree-node__info
                div.tree-node__label(:title="node.label") {{ node.label }}
            div.tree-node__action
                input.form-input(
                    v-model="selectedNodes"
                    :id="node.id"
                    :name="node.id"
                    :value="node.id"
                    @change="selectNode(node.id)"
                    type="checkbox")

        transition(name="slide-fade")
            HierarchicalTree(
                v-if="isNodeExpanded(node.jsonKey.name)"
                :nodes="node.children"
                :rootParentId="rootParentId"
                :childrenSize="childrenSize"
                class="children-node")
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapActions, mapMutations } from 'vuex'

import { includes } from 'lodash'

export default {
    name: 'HierarchicalTree',

    props: {
        nodes: { type: Array, required: true },
        rootParentId: { type: String, required: false, default: null },
        childrenSize: { type: Number, required: false, default: 0 }
    },

    mounted() {
        // make sur store && view data comply concerning node selection

        if (this.nodes.length > 0) {
            for (const _node of this.nodes) {
                if (_node.account_status === 'active') {
                    this.selectedNodes.push(_node.id)
                }
            }
            this.selectNodes({ taxoId: this.rootParentId, nodesIds: this.selectedNodes, action: 'add', clusterSize: this.childrenSize })
        }
    },

    data() {
        return {
            selectedNodes: [],
            selectedNode: null
        }
    },

    computed: {
        ...mapState('ui/secondParty', {
            selectedClusters: state => state.selectedClusters,
            selectAllTaxoIds: state => state.selectAllTaxoIds,
            expandedTaxoIds: state => state.expandedTaxoIds
        }),
        selectedCluster() {
            return this.selectedClusters[this.rootParentId]
        }
    },

    methods: {
        ...mapActions('ui/secondParty', ['selectNodes']),
        ...mapMutations('ui/secondParty', ['setExpandedClustersIds', 'setModifiedClusters']),
        expandNode(node) {
            if (this.expandedTaxoIds.hasOwnProperty(this.rootParentId)) {
                if (includes(this.expandedTaxoIds[this.rootParentId], node.jsonKey.name)) {
                    this.setExpandedClustersIds({ taxoId: this.rootParentId, cluster: node, action: 'close' })
                } else {
                    this.setExpandedClustersIds({ taxoId: this.rootParentId, cluster: node, action: 'expand' })
                }
            }
        },
        isNodeExpanded(nodeId) {
            return includes(this.expandedTaxoIds[this.rootParentId], nodeId)
        },
        selectNode(nodeId) {
            this.selectedNode = nodeId
            const action = includes(this.selectedClusters[this.rootParentId], nodeId) ? 'remove' : 'add'
            this.selectNodes({ taxoId: this.rootParentId, nodeId: nodeId, action: action, clusterSize: this.childrenSize })
            this.setModifiedClusters({ action: action, id: nodeId })
        }
    }
}
</script>
